<div class="h-100">

  <div class="container-fluid h-100">
    <div class="row p-0 h-100">

      <!-- Place list or place detail view-->
      <div class="col-12 col-lg-7 p-0 h-100" style="overflow: scroll">
        <router-outlet></router-outlet>
      </div>

      <!-- Map view-->
      <div class="col-12 col-lg-5 p-0 h-100 hide-sm hide-md hide-lg">
        <app-place-map></app-place-map>
      </div>
    </div>
  </div>

</div>
